import React from 'react';
import Hero from 'components/hero';
import FeatureCard from 'components/feature-card';
import FancyButton from 'components/fancy-button';
import ImageWorker from 'svg/illustrations/home-worker.svg';
import ImageProvider from 'svg/illustrations/home-provider.svg';
import './style.css';

const HomeRoutes = () => {
  return (
    <Hero class="grid" className="bg-third">
      <FeatureCard className="card">
        <div className="home-illustration">
          <img src={ImageWorker} alt="worker" />
        </div>
        <div className="content">
          <h3>Health and Social Care Workers</h3>
          <p>Begin your journey to flexible working at better rates of pay.</p>
          <FancyButton href="/workers">Find out more</FancyButton>
        </div>
      </FeatureCard>

      <FeatureCard className="card">
        <div className="home-illustration">
          <img src={ImageProvider} alt="worker" />
        </div>
        <div className="content">
          <h3>Health and Social Care Providers </h3>
          <p>
            Begin your journey to less Agency fees, more control of staffing
            levels and unlimited staff resources.
          </p>
          <FancyButton href="/employers">Find out more</FancyButton>
        </div>
      </FeatureCard>
    </Hero>
  );
};

export default HomeRoutes;
